document.addEventListener('DOMContentLoaded', function() {
  // Ensure we don't initialize twice
  if (window.productAccordionInitialized) return;
  window.productAccordionInitialized = true;
  
  console.log('Initializing product info accordions');
  
  // Get all accordion containers
  const accordionContainers = document.querySelectorAll('.product-info-accordion__container');
  
  accordionContainers.forEach(container => {
    // Get all details elements
    const details = container.querySelectorAll('details');
    
    // Close all details by default
    details.forEach(detail => {
      detail.removeAttribute('open');
    });
    
    // Add click listeners to ensure only one is open at a time
    details.forEach(detail => {
      const summary = detail.querySelector('summary');
      
      // Add click handler
      summary.addEventListener('click', function(e) {
        // If this detail is being closed, we don't need to do anything
        if (detail.hasAttribute('open')) {
          return;
        }
        
        // If this detail is being opened, close all others
        details.forEach(otherDetail => {
          if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
            otherDetail.removeAttribute('open');
          }
        });
      });
    });
  });
});
